!function() {
  "use strict";
  
  const API_TEMPLATE_SELECTOR = "[data-api-related-template]";
  const PRODUCT_ITEM_SELECTOR = ".product-item";
  const GRID_ITEM_SELECTOR = "[data-grid-item]";
  const RELATED_SECTION_SELECTOR = "[data-related-section]";
  const RECENTLY_VIEWED_CLASS = "recently-viewed";
  const GRID_SLIDER_CLASS = "grid-slider";
  const RECENTLY_VIEWED_WRAPPER_SELECTOR = "[data-recently-viewed-wrapper]";
  const LIMIT_ATTRIBUTE = "data-limit";
  const PRODUCT_ID_ATTRIBUTE = "data-product-id";
  const HIDDEN_CLASS = "is-hidden";
  const MOBILE_SLIDER_CLASS = "grid--mobile-slider";

  if (!customElements.get("related-products")) {
    customElements.define("related-products", class extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.id;
        this.relatedItemsCount = 0;
        this.wrapper = this.querySelector(RECENTLY_VIEWED_WRAPPER_SELECTOR);
        this.recentlyViewedElement = this.querySelector(RECENTLY_VIEWED_CLASS);
      }

      connectedCallback() {
        this.loadRelatedProducts();
        this.loadRecentlyViewedProducts();
      }

      loadRelatedProducts() {
        const relatedSection = this.querySelector(RELATED_SECTION_SELECTOR);
        if (!relatedSection) return;

        const productId = relatedSection.getAttribute(PRODUCT_ID_ATTRIBUTE);
        const limit = relatedSection.getAttribute(LIMIT_ATTRIBUTE);
        const requestUrl = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${limit}&product_id=${productId}&intent=related`;

        fetch(requestUrl)
          .then(response => response.text())
          .then(responseText => this.handleRelatedProductsResponse(responseText, relatedSection))
          .catch(() => this.hideSection(relatedSection));
      }

      handleRelatedProductsResponse(responseText, relatedSection) {
        const tempDiv = document.createElement("div");
        const parsedResponse = new DOMParser().parseFromString(responseText, "text/html");
        tempDiv.innerHTML = parsedResponse.querySelector(API_TEMPLATE_SELECTOR).innerHTML;

        const gridItemsCount = tempDiv.querySelectorAll(GRID_ITEM_SELECTOR).length;

        if (gridItemsCount > 0) {
          relatedSection.innerHTML = tempDiv.innerHTML;
          this.relatedItemsCount = gridItemsCount;

          // Add mobile slider class if no mobile columns are set
          if (parseInt(relatedSection.style.getPropertyValue("--COLUMNS-MOBILE")) === 0) {
            const firstGridItem = relatedSection.querySelector(GRID_ITEM_SELECTOR);
            if (firstGridItem && firstGridItem.parentElement) {
              firstGridItem.parentElement.classList.add(MOBILE_SLIDER_CLASS);
            }
          }
        } else {
          this.hideSection(relatedSection);
        }

        this.updateVisibility();
      }

      loadRecentlyViewedProducts() {
        this.recentlyViewedElement?.addEventListener("theme:recently-viewed:loaded", () => {
          this.handleRecentlyViewedResponse();
        });
      }

      handleRecentlyViewedResponse() {
        const minimumRequired = parseInt(this.recentlyViewedElement.dataset.minimum);
        const productItems = this.recentlyViewedElement.querySelectorAll(PRODUCT_ITEM_SELECTOR);
        const gridSlider = this.recentlyViewedElement.querySelector(GRID_SLIDER_CLASS);
        
        const showWithoutWrapper = !this.wrapper && productItems.length > 0;
        const showWithWrapper = this.wrapper && productItems.length >= minimumRequired;

        if (showWithoutWrapper || showWithWrapper) {
          if (showWithWrapper && this.wrapper) {
            this.wrapper.classList.remove(HIDDEN_CLASS);
          }

          this.recentlyViewedElement.classList.remove(HIDDEN_CLASS);
          this.recentlyViewedElement.dispatchEvent(new CustomEvent("theme:tab:check", { bubbles: true }));

          if (gridSlider) {
            gridSlider.dispatchEvent(new CustomEvent("theme:grid-slider:init", { bubbles: true }));
          }
        }

        this.updateVisibility();
      }

      hideSection(sectionElement) {
        sectionElement.dispatchEvent(new CustomEvent("theme:tab:hide", { bubbles: true }));
      }

      updateVisibility() {
        const shouldHide = Shopify.Products.getConfig().howManyToShow < 1 && this.relatedItemsCount < 1;
        this.classList.toggle(HIDDEN_CLASS, shouldHide);
      }
    });
  }
}();
